import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

import { PageHeader } from "@/components/common/page-header"
import { DriveBrowser } from "@/features/files/drive-browser"
import { DrivePageActions } from "@/features/files/drive-page-actions"
import { DriveProvider } from "@/features/files/drive-provider"
import { DriveUploadQueue } from "@/features/files/drive-upload-queue"
import { driveQueries } from "@/queries/drive"
import type { DriveOwner } from "@/types/drive"

const searchSchema = z.object({
  folder: z.uuid().optional(),
})

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/firms/$firmId/files/"
)({
  validateSearch: searchSchema,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps, params }) =>
    context.queryClient.ensureQueryData(
      driveQueries.list(
        { type: "firm", id: params.firmId },
        deps.folder ?? null
      )
    ),
  component: FirmFilesPage,
})

function FirmFilesPage() {
  const { firmId } = Route.useParams()
  const { folder } = Route.useSearch()
  const navigate = Route.useNavigate()
  const owner: DriveOwner = { type: "firm", id: firmId }

  return (
    <DriveProvider owner={owner} folderId={folder ?? null}>
      <PageHeader title="Files" actions={<DrivePageActions />} />
      <DriveBrowser
        onFolderChange={(folderId) =>
          void navigate({ search: { folder: folderId ?? undefined } })
        }
      />
      <DriveUploadQueue />
    </DriveProvider>
  )
}
